<template>
    <div>
        <el-table :data="tableData" tooltip-effect="dark" :stripe="true" :header-cell-style="tableHeaderCellStyle">
            <el-table-column prop="learnAssesment.assesmentName" label="考核名称" align="center"></el-table-column>
            <el-table-column prop="subjectivityScore" label="主观题得分" align="center"></el-table-column>
            <el-table-column prop="objectivesScore" label="客观题得分" align="center"></el-table-column>
            <el-table-column prop="scoreSum" label="考核得分" align="center"></el-table-column>
            <el-table-column  label="教师批改" align="center">
              <template slot-scope="scope">
                {{scope.row.gradedFlag == true ? '已批该' : '未批改'}}
              </template>
            </el-table-column>
            <el-table-column label="是否合格" align="center">
              <template slot-scope="scope">
                {{scope.row.passingFlag == true ? '合格' : '不合格'}}
              </template>
            </el-table-column>
            <el-table-column prop="learnAssesment.assesmentScore" label="总分" align="center"></el-table-column>
            <el-table-column prop="sysUser.nickName" label="评分教师" align="center"></el-table-column>
        </el-table>
        <el-pagination
            class="mb-pagination"
            @current-change="handleCurrentChange"
            :current-page="curPage"
            layout="total, prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import CommonStyle from "@/utils/CommonStyle";
    export default {
        name: "StudentAssessmentScore",
        data() {
            return {
                tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
                tableData: [],
                total: 0,
                curPage: 1,
            };
        },
        mounted() {
            this.queryData(1);
        },
        methods: {
            queryData(curPage) {
                let that = this;
                that.HttpConnection.get("/learn/record/stuList", {
                    params: {
                        pageNum: curPage,
                        pageSize: 10
                    }
                }).then(function(response) {
                    that.tableData = response.rows;
                    that.total = response.total;
                });
            },
            handleCurrentChange(val) {
                this.curPage = val;
                this.queryData(val);
            }
        }
    };
</script>

<style scoped lang="scss">

</style>
